import {Field, useFormikContext} from "formik";
import {TextField} from "formik-mui";
import React, {useEffect} from "react";
import {useSkontoBerechnung} from "../../hooks/useSkontoBerechnung";

export default function SkontoFields({
                                         bruttoBetrag,
                                         rechnungsBetragChanged,
                                         isAbweichenderRechnungsBetrag,
                                         skontoBetrag,
                                         zahlBetrag,
                                         rechnungsTyp,
                                     }: {
    bruttoBetrag: string;
    rechnungsBetragChanged: boolean;
    isAbweichenderRechnungsBetrag: boolean;
    skontoBetrag: string;
    zahlBetrag: string;
    rechnungsTyp: string;
}) {
    const {setFieldValue} = useFormikContext();
    const {handleSkontoInProzentChange, handleSkontoBetragChange} =
        useSkontoBerechnung({
            bruttoBetrag,
            rechnungsBetragChanged,
            isAbweichenderRechnungsBetrag,
            skontoBetrag,
            zahlBetrag,
        });

    useEffect(() => {
        if (rechnungsTyp?.toUpperCase() === "GUTSCHRIFT") {
            setFieldValue("faelligkeitMitSkonto", "9999-01-01");
        }
    }, [rechnungsTyp, setFieldValue]);

    return (
        <>
            <Field
                component={TextField}
                name="skonto1InProzent"
                label={"Skonto in %"}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    handleSkontoInProzentChange(e);
                }}
                inputProps={{style: {textAlign: "right"}}}
            ></Field>
            <Field
                component={TextField}
                name="skontoBetrag"
                label={"Skontobetrag in €"}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    handleSkontoBetragChange(e);
                }}
                inputProps={{style: {textAlign: "right"}}}
            ></Field>
            <Field
                component={TextField}
                name="zahlbetrag"
                label={"Zahlbetrag in €"}
                type={"string"}
                disabled={true}
                InputLabelProps={{shrink: true}}
                inputProps={{style: {textAlign: "right"}}}
            ></Field>
            <Field
                component={TextField}
                name="faelligkeitMitSkonto"
                label={"Fälligkeit mit Skonto"}
                type={"date"}
                disabled={rechnungsTyp ? rechnungsTyp.toUpperCase() === 'GUTSCHRIFT' : false}
                InputLabelProps={{shrink: true}}
            ></Field>
        </>
    );
}
